import { accountIdFormat } from "@redotech/redo-account-id";
import { processingGroupIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const setProcessingGroupMerchants = {
  name: "setProcessingGroupMerchants" as const,
  input: z.object({
    processingGroupId: processingGroupIdFormat.schema,
    merchantAccountIds: z.array(accountIdFormat.schema),
  }),
  output: z.null(),
};
